<section class="hero" id="hero">
  <!-- Text content — centered, full width -->
  <div class="hero__content">
    <div class="hero__heading">
      <h1 class="hero__title h1">Tu espacio en Almería para crear y reconectar contigo</h1>
      <p class="hero__subtitle body-m">
        Experiencias y talleres para personas que buscan reconectar consigo mismas y sentirse 
        <br>mejor a través de herramientas creativas
      </p>
      <button class="btn btn-outline hero__cta" (click)="scrollToTalleres()">
        <span class="hero__cta-label">Próximos talleres</span>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M3.75 14.25L14.25 3.75M14.25 3.75H6.75M14.25 3.75V11.25" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Images row — full width, below content -->
  <div class="hero__images">
    <div class="hero__image">
      <img src="images/hero-main.png" alt="Taller de creatividad Aruma" loading="eager">
    </div>
    <div class="hero__image">
      <img src="images/hero-secondary.png" alt="Espacio creativo Aruma en Almería" loading="eager">
    </div>
  </div>
</section>
